export enum RequestStatusEnum {
  DRAFT = "DRAFT",
  REQUESTED = "REQUESTED",
  REPLIED = "REPLIED",
  ACCEPTED = "ACCEPTED"
}
